
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import "rxjs/Rx";

import { Baseservice } from './baseservice'

import { AuthenticationService } from './authentication.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class VehicleService extends Baseservice {
    private allVehicles = new Subject<any[]>();

    constructor(http: HttpClient, authentication: AuthenticationService,private hhtpClicent:HttpClient) {
        super("vehicle",http, authentication);
    }
    setVehicleReplament(data: any[]) {
        this.allVehicles.next(data);
      }
      getVehicleReplament(): Observable<any[]> {
        return this.allVehicles.asObservable();
      }
    get() {
        return this.getVehicle(this.url + "/vehicle");
    }
    getAllVe(id:any) {
        return this.getVehicle(this.url+'/'+id);
    }
    getPermitsAppVecle(id:any) {
        return this.getVehicle(this.url+'/byapp/'+id);
    }
    getByPermitId(id:any)
    {
        return this.getVehicle(this.url+'/getByPermitId/'+id);
    }
    getPermitsAppVecleEntry(id:any) {
        return this.getVehicle(this.url+'/byvehicle-permit-entry/'+id);
    }
    getCarrierPermitsAppVecleEntry(id:any,appid) {
        return this.getVehicle(this.url+'/byvehicle-carrier-permit-entry/'+id+'/'+appid);
    }
    getVehicleBy(id:any) {
        return this.getVehicle(this.url+'/byid/'+id);
    }
    getAllVehicles() {
        return this.getVehicle(this.url);
    }
    getById(id: any) {
        return this.getVehicle(this.url + "/find/" + id);
    }

    isVehicleAttachedToPermit(id:any, carrierId:any)
    {
      return this.http.get(this.url+"/app/IsVehicleAttachedToPermit/" + id +'/'+ carrierId);
    }

    

    getVehicle(url: string) {
        return this.getRequest(url).pipe(map(response => response)); 
    }

    postVehicle(object : any) {
        let body = object;
        return this.http.post(this.url+"/app/list", body);
    }///start/date
    postVehicleStartDate(object : any) {
        let body = object;
        return this.http.post(this.url+"/start/date", body);
    }//delete/vehicle/list
    deleteVehiclesList(object : any) {
        let body = object;
        return this.http.post(this.url+"/delete/vehicle/list", body);
    }//delete/vehicle/list

    putVehicle(object) {
        let body = object;
        return this.http.put(this.url,body);
    }
    updateVehicle(object) {
        let body = object;
        return this.http.put(this.url+'/update',body);
    }
    deleteVehicle(idsObject : any){
      
        return this.http.post(this.url+"/app/delete", idsObject);
    }
    removeVehicle(id){
      
        return this.http.get(this.url+"/app/delete/"+id);
    }
    getVehicleByVin(vin){
        return this.http.get(this.url+"/vehicleEntry/"+vin);

    }
    getVehicleValidatorByVin(vin){
        return this.http.get(this.url+"/vehicle-validator/byVIN/"+vin);

    }
    getVehicleValidatorByReg(reg){
        return this.http.get(this.url+"/vehicle-validator/byReg/"+reg);

    }
    getVehiclesList(id){
        return this.http.get(this.url+"/person/"+id);
    }
   

}

